export default __webpack_public_path__ + "static/media/training-illustration26.e3735009.png";